import * as React from "react";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { isNullOrEmpty } from "../../../../../../../../react-core/Utils/Arrays";
import { DrawdownPaymentDestinationAllocation } from "../../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownPaymentDestinationAllocation";
import { Typography } from "../../../../../../../Shared/Typography/Typography";
import { getBankAccountOptions } from "../../../Resource/Helper";

interface IBankDetailsProps {
    data?: any;
    extraInfo: any;
}

interface IBankDetailsState {}

export class BankDetails extends FormComponent<IBankDetailsProps, IBankDetailsState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data } = this.props;
        return (
            <>
                <h2 className="mt-48">Bank details</h2>
                <div className="row">
                    <div className="col-12 col-sm-fluid">
                        <h4>Before</h4>
                        <Typography
                            type={"auto-width"}
                            config={this.getValues(data?.DrawdownIncome?.AnnualIncome?.IncomePaymentAllocations)}
                        />
                    </div>

                    <div className="col-12 col-sm-fluid">
                        <h4>After</h4>
                        <Typography
                            type={"auto-width"}
                            config={this.getValues(
                                data?.DrawdownIncomeAmendmentInstruction.Income?.IncomePaymentAllocations
                            )}
                        />
                    </div>
                </div>
            </>
        );
    }

    private getValues(data: DrawdownPaymentDestinationAllocation[]) {
        const bankAccountOptions: Map<number, string> = getBankAccountOptions(this.props.extraInfo);
        const bankAccountDetails = [];
        if (!isNullOrEmpty(data)) {
            data.forEach((bankAccount, index) => {
                bankAccountDetails.push(
                    { title: `Bank account ${index + 1}`, data: bankAccountOptions.get(bankAccount?.BankAccountId) },
                    { title: "Portion of income", data: bankAccount?.Allocation }
                );
            });
        }
        return bankAccountDetails;
    }
}
